import { computed, inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

import { AdminModeService } from '../../../auth/admin-mode/admin-mode.service';
import { DomainService } from '../../../auth/authentication/domain.service';
import { ConsentType } from '../../customer/model/consent-type.model';
import { FeatureVisibilityService } from '../../customer/services/feature-visibility.service';

@Injectable({
  providedIn: 'root',
})
export class DealerConsentVisibilityService {
  private readonly logger = inject(NGXLogger);
  private readonly domainService = inject(DomainService);
  private readonly adminModeService = inject(AdminModeService);
  private readonly featureVisibilityService = inject(FeatureVisibilityService);
  private readonly location = inject(Location);

  private readonly isInternetUrl = computed(() => {
    if (this.domainService.isCDFUrl()) {
      return this.domainService.isInternetUrl();
    } else {
      // not CDF directly, but rather an embedded use case, currently only AWP
      const domain = this.location.hostname;
      if (!domain.startsWith('awp')) {
        this.logger.warn('#CDFTF0217 Dealer consent visibility check on unexpected domain:', domain);
      }
      // Return true if not an intranet domain
      return !domain.endsWith('.net') && !domain.endsWith('.cloud');
    }
  });

  readonly showDealerConsent = computed(() => {
    return (
      (this.isInternetUrl() || this.adminModeService.isAdminModeActive()) &&
      !this.featureVisibilityService.isHidden(ConsentType.DEALER_CONSENT)
    );
  });
}
